import { formatPrice, type FractionDigits } from '../currency';

export interface StrikePriceProps {
  /** The regular price a promotion replaced, in the operator currency. */
  amount: number;
  decimals?: FractionDigits;
  className?: string;
}

/**
 * A regular price struck through and muted, so it reads as "not what you pay".
 * It takes its colour from the text around it (muted by opacity), which keeps
 * it legible on every template and theme without a colour of its own.
 */
export function StrikePrice({ amount, decimals = 2, className = '' }: StrikePriceProps) {
  return (
    <s className={`whitespace-nowrap font-normal line-through opacity-60 ${className}`.trimEnd()}>
      <span className="sr-only">Regular price </span>
      {formatPrice(amount, decimals)}
    </s>
  );
}
